<template>
	<nav class="navbar navbar-expand navbar-light bg-light noprint">
		<div class="container-fluid">
            <div class="collapse navbar-collapse " id="navbarSupportedContent">
                <ul class="title-box d-none d-sm-none d-lg-none d-xl-block">
                    <img class="tdk-logo" src="@/assets/TDK_logo.png" />
                </ul>
                <div class="mx-auto">
                    <button class="btn btn-primary m-1" @click.prevent="togglePrintView" type="button">Szerkesztés/Nyomtatás</button>
                    <label for="xmlUpload" class="btn btn-primary m-1">XML betöltés</label>
                    <input id="xmlUpload" style="display:none;" class="btn btn-primary m-1" type="file" @change="onChange($event)" title="XML feltöltés" />
                    <button class="btn btn-primary m-1" @click.prevent="saveJegyzokonyvXml" type="button">XML mentés</button>
                    <button class="btn btn-primary m-1" @click.prevent="validateView" type="button">Véglegesítés</button>
                    <!-- <button class="btn btn-primary m-1" @click.prevent="testXml" type="button">(Teszt XML betöltés)</button> -->
                </div>
                <div class="title-box d-none d-sm-none d-md-none d-lg-block">
                    <div class="title">TDK jegyzőkönyv szerkesztő</div>
                    <div class="version">
                        v{{ $app_version }} <a class="help-link" target="_blank" href="TDK_jegyzokonyv_kitoltesi_utmutato.pdf">Útmutató</a>
                    </div>
                </div>
            </div>
		</div>
	</nav>
	<div v-if="loadResult == 'e'" class="alert alert-danger">{{ loadMessage
                        }}
                    </div>
	<div v-if="loadResult == 's'" class="alert alert-success">{{ loadMessage }}</div>
	<div v-if="loadResult == 'w'" class="alert alert-warning">{{ loadMessage }}</div>
	<jegyzokonyv ref="jegyzokonyvRef" />
</template>
<script>
import Jegyzokonyv from './components/Jegyzokonyv.vue'

export default {
	components: {
		Jegyzokonyv
	},
    data() {
        return {
            loadResult: '',
            loadMessage: ''
        }
    },
	methods: {
		async testXml() {
			let data = await fetch('sample.xml');
            let text = await data.text();
			this.$storage.loadJegyzokonyvXml(this.$refs.jegyzokonyvRef.jegyzokonyv, text);
		},
		togglePrintView() {
			if (this.$refs.jegyzokonyvRef.phase == 'edit')
				this.$refs.jegyzokonyvRef.phase = 'print';
			else
				this.$refs.jegyzokonyvRef.phase = 'edit';
		},
        validateView() {
			this.$refs.jegyzokonyvRef.phase = 'validate';
        },
		saveJegyzokonyvXml() {
			var xmlString = this.$storage.saveJegyzokonyvXml(false);

            const blob = new Blob([xmlString], { type: 'application/xml' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = this.$storage.filename();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
		},
		async onChange(event) {
			var file = event.target.files[0];
			if (file) {
				var txt = await file.text();
				this.$storage.loadJegyzokonyvXml(this.$refs.jegyzokonyvRef.jegyzokonyv, txt);
				this.loadResult = this.$refs.jegyzokonyvRef.jegyzokonyv.loadResult;
				this.loadMessage = this.$refs.jegyzokonyvRef.jegyzokonyv.loadMessage;
				setTimeout(this.clearMessage, 3000);
			}
		},
		clearMessage() {
            this.loadResult = '';
		}
	},
}
</script>

<style>
    @media print {
        .noprint {
            visibility: hidden;
        }
    }

    .tdk-logo {
        height: 60px;
    }

    .btn-primary {
        background-color: #EF4C22;
        border-color: #EF4C22;
        font-size: 20px;
        font-weight: 600;
        color: white;
    }

    .btn-secondary {
        background-color: #EF4C22;
        border-color: #EF4C22;
        font-size: 16px;
        font-weight: 300;
        color: white;
    }

    .btn-primary:hover {
        color: #fff;
        background-color: #fc513f;
        border-color: #0a58ca
    }

    .navbar {
        justify-content: center;
    }

    .title-box {
        text-align: center;
        padding: 0px;
        margin: 0px;
    }

    .title {
        font-size: 17px;
        font-weight: 600;
        padding: 0px;
        margin: 0px;
    }

    .version {
        font-size: 15px;
        font-weight: 100;
        padding: 0px;
        margin: 0px;
    }

    h3 {
        font-family: font-family Roboto, sans-serif;
        font-style: italic;
        font-size: 18px;
        font-weight: 600;
    }

    .help-link {
        color: #fc513f;
        text-decoration: none;
    }
</style>